import _ from "lodash";
import React, { useEffect, useState } from "react";
import { Button, Col, Input, Label, Row } from "reactstrap";
import { toast } from "react-toastify";
import axios from "axios";
import Select, { components } from "react-select";
import { DesktopContainer } from "../layouts";
import { CustomerTypeahead } from "./";
import { api, constants, dateHelpers } from "../utils";
import { useLocation, useParams } from "react-router-dom";

const RadioButttonTypes = {
   OPEN: 1,
   HISTORY: 2,
};

export default function CreateCoA() {
   const cancelToken = axios.CancelToken;
   const source = cancelToken.source();
   const location = useLocation();
   const { order, item, cust, isConsigned } = useParams();
   const customStyles = {
      menu: (base) => ({
         ...base,
         zIndex: 2, // Set z-index to make sure menu is displayed above other elements
         borderRadius: 0,
         position: "absolute",
         width: "100%",
         top: "100%", // Position menu below select
         left: 0,
         marginTop: "4px", // Add margin to separate menu from select
         boxxlhadow: "0px 8px 16px rgba(0, 0, 0, 0.1)", // Add box-shadow to menu
      }),
      menuList: (base) => ({
         ...base,
         minHeight: "30px",
         maxHeight: "500px",
         width: "100%",
         position: "relative",
         overflowY: "auto",
         color: "inherit", // Inherit text color from parent
         backgroundColor: "inherit", // Inherit background color from parent
         "&:focus": {
            outline: "none",
         },
         "&::-webkit-scrollbar": {
            width: "10px", // Adjust the width of the scrollbar
         },
         "&::-webkit-scrollbar-track": {
            backgroundColor: "#e4e4e4",
            borderRadius: "4px",
         },
         "&::-webkit-scrollbar-thumb": {
            backgroundColor: "#c5c5c5",
            borderRadius: "0px",
            minHeight: "20px",
            height: "auto",
            width: "10px", // Adjust the width of the scrollbar thumb
         },
      }),
   };

   const [currentCustomer, setCurrentCustomer] = useState(
      cust
         ? {
            Customer: { value: cust, label: cust, },
            isConsignedCustomer: isConsigned?.toLocaleLowerCase() === "true",
            forceHistory: false,
         }
         : {
            Customer: location?.state?.currentCustomer?.Customer,
            isConsignedCustomer: location?.state?.currentCustomer?.isConsignedCustomer,
            forceHistory: false,
         }
   );
   const [currentItems, setCurrentItems] = useState([]);
   const [currentOrder, setCurrentOrder] = useState(order ? { value: order, label: order } : location?.state?.currentOrder);
   const [currentOrders, setCurrentOrders] = useState([]);
   const [currentRadio, setCurrentRadio] = useState(1);
   const [historyOrders, setHistoryOrders] = useState([]);
   const [isLoadingSelect, setIsLoadingSelect] = useState(false);
   const [currentItem, setCurrentItem] = useState(item ? { value: item, label: item } : location?.state?.currentItem);

   useEffect(() => {
      if (_.isNil(currentCustomer.Customer)) {
         clearData();
         return;
      }
      let payload = {
         CustomerId: currentCustomer.Customer.value,
         AllTransfers: false,
         SortField: "DOCDATE",
         SortDirection: "Asc",
         isConsignedCustomer: false,
      };
      if (currentCustomer.isConsignedCustomer) {
         payload.isConsignedCustomer = true;
         payload.orderType = 2;
      } else {
         payload.orderType = 1;
      }

      api.postS("Quality/PageLoad", payload, source.token).then((r) => {
         if (r.data?.success) {
            if (r.data.success) {
               if (r.data.consignedList) {
                  if (r.data.consignedList.length === 0) {
                     callBackConsignedHistory();
                  } else {
                     let selectList = _.map(r.data.consignedList, (x) => {
                        return { label: x.orderId, value: x.orderId };
                     });
                     selectList = _.orderBy(selectList, ["label"], ["desc"]);
                     setCurrentRadio(RadioButttonTypes.OPEN);
                     setHistoryOrders([]);
                     setCurrentOrders(selectList);
                  }
               } else if (r.data.orderList) {
                  if (currentCustomer.forceHistory || r.data.orderList.length === 0) {
                     callBackOrderHistory();
                  } else {
                     let selectList = _.map(r.data.orderList, (x) => {
                        return { label: x.orderId, value: x.orderId };
                     });
                     selectList = _.orderBy(selectList, ["label"], ["desc"]);
                     setCurrentRadio(RadioButttonTypes.OPEN);
                     setHistoryOrders([]);
                     setCurrentOrders(selectList);
                  }
               }
            }
         } else {
            toast.error("could not return results...");
         }
      });
      return () => {
         source.cancel("axios request cancelled");
      };
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [currentCustomer]);

   useEffect(() => {
      if (currentOrder === null) return;
      const payload = {
         OrderType: currentRadio,
         InvoiceNumber: _.trim(currentOrder?.value),
      };
      api
         .postS("Quality/LoadItemList", payload, source.token)
         .then((r) => {
            if (r.data?.success) {
               if (r.data.list.length === 0) {
                  setCurrentItem({
                     label: "--- No items were found with a spec ---",
                     value: -1,
                  });
                  setCurrentItems([]);
               } else {
                  setCurrentItems(r.data.list);
                  // currentItem?.value ? null : setCurrentItem(null);
                  if (!item && !location?.state?.currentItem?.value) {
                     setCurrentItem(null);
                  }
               }
            } else {
               toast.info(
                  "Query not successful try again or contact an Administrator"
               );
               throw new Error("failed to load items list");
            }
         })
         .catch(api.catchHandler);
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [currentOrder]);

   const callBackConsignedHistory = () => {
      let payload = {
         CustomerId: currentCustomer.Customer.value,
         AllTransfers: true,
         SortField: "DOCDATE",
         SortDirection: "Asc",
         isConsignedCustomer: true,
      };
      return api.postS("Quality/PageLoad", payload, source.token).then((r) => {
         if (r.data.consignedList.length === 0) {
            toast.info("No current or history transfers found");
         } else {
            let selectList = _.map(r.data.consignedList, (x) => {
               return { label: x.orderId, value: x.orderId };
            });
            selectList = _.orderBy(selectList, ["label"], ["desc"]);
            setCurrentRadio(RadioButttonTypes.HISTORY);
            setHistoryOrders(selectList);
            setCurrentOrders([]);
         }
      });
   };

   const callBackOrderHistory = () => {
      const payload = {
         CustomerId: currentCustomer.Customer.value,
         OrderType: 2,
         isConsignedCustomer: false,
      };
      return api.postS("Quality/PageLoad", payload, source.token).then((r) => {
         if (r.data.orderList.length === 0) {
            toast.info("No current or history transfers found");
         } else {
            let selectList = _.map(r.data.orderList, (x) => {
               return { label: x.orderId, value: x.orderId };
            });
            selectList = _.orderBy(selectList, ["label"], ["desc"]);
            setCurrentRadio(RadioButttonTypes.HISTORY);
            setHistoryOrders(selectList);
            setCurrentOrders([]);
         }
      });
   };

   const clearData = () => {
      setHistoryOrders([]);
      setCurrentOrders([]);
   };

   function handleCustomerChange(newCustomer) {
      setCurrentItem(null);
      setCurrentOrder(null);
      setCurrentCustomer({ ...currentCustomer, Customer: newCustomer });
   }

   const loadOptions = () => {
      setIsLoadingSelect(true);

      // Simulate fetching options with a delay
      setTimeout(() => {
         setIsLoadingSelect(false);
      }, 100);
   };

   const MenuList = ({ children, ...props }) => {
      return (
         <components.MenuList {...props} style={customStyles.menuList}>
            <div
               style={{
                  ...(isLoadingSelect && { opacity: 0.5 }),
                  ...customStyles.loadingIndicator,
               }}
            >
               {isLoadingSelect ? (
                  <>
                     <div style={customStyles.loadingIndicator}>
                        <span className="ml-2">&nbsp;&nbsp;Loading</span>
                        <div className="loading-dots">
                           <span></span>
                           <span></span>
                           <span></span>
                        </div>
                     </div>
                  </>
               ) : (
                  children
               )}
            </div>
         </components.MenuList>
      );
   };

   const radioSwitch = (radioOption) => {
      setCurrentRadio(radioOption);
      if (radioOption === RadioButttonTypes.HISTORY) {
         setCurrentCustomer({
            ...currentCustomer,
            forceHistory: true,
         });
         setCurrentOrder(null);
      } else {
         setCurrentCustomer({
            ...currentCustomer,
            forceHistory: false,
         });
         setCurrentOrder(null);
      }
   };

   const runCoAReport = () => {
      if (!currentOrder || !currentItem) return;
      const payload = {
         InvoiceNumber: _.trim(currentOrder.value),
         OrderType: currentRadio,
         itemNumber: _.trim(currentItem.value),
      };
      api
         .post("Reference/ItemExist", payload)
         .then((r) => {
            if (r && r.data && r.data.exist) {
               api
                  .postDownloadBinary(
                     "Report/CoAReport",
                     payload,
                     constants.MIME_PDF,
                     `CoA_${currentItem.value}_${dateHelpers.toLongDateString(
                        new Date()
                     )}.pdf`,
                     "There was an error downloading this CoA Report"
                  )
                  .then((res) => {
                     if (res?.data === false) {
                        toast.error(res.message);
                     }
                  })
                  .catch(api.catchHandler);
            } else {
               toast.error(
                  `Could not find an item with this identifier ${currentItem.value}`
               );
            }
         })
         .then((res) => {
            if (res?.data === false) {
               toast.error(res.message);
            }
         })
         .catch(api.catchHandler);
   };

   return (
      (document.title = `Create CoA`),
      (
         <DesktopContainer screenName={"CoA Search"}>
            <div className="filter-header stick-top mb-3">
               <Row className="mt-3">
                  <Col
                     xxl="3"
                     className="pt-2"
                     style={{ textAlign: "right", marginRight: "5px", color: "white" }}
                  >
                     <h5>Customer:</h5>
                  </Col>
                  <Col xxl="4" style={{ paddingRight: "0px" }}>
                     <CustomerTypeahead
                        value={currentCustomer.Customer}
                        onChange={handleCustomerChange}
                     />
                  </Col>
               </Row>
               {currentCustomer.Customer && (
                  <>
                     <hr />
                     <Row>
                        <Col xxl="3" style={{ textAlign: "right", color: "white" }}>
                           <h5>Order Type</h5>
                        </Col>
                     </Row>
                     <Row className="mt-3">
                        <Col xxl="3" style={{ textAlign: "right", color: "white" }}>
                           <Input
                              type="radio"
                              id="OpenOrders"
                              name="orderType"
                              value={RadioButttonTypes.OPEN}
                              checked={currentRadio === RadioButttonTypes.OPEN}
                              onChange={() => radioSwitch(RadioButttonTypes.OPEN)}
                           />
                           <Label htmlFor="OpenOrders" className="ms-2">
                              Open Orders
                           </Label>
                        </Col>
                        <Col xxl="4">
                           <Select
                              classNamePrefix="serviceThreadSelect"
                              options={currentOrders}
                              value={currentOrder}
                              onChange={(opt) => setCurrentOrder(opt)}
                              isDisabled={ _.isEmpty(currentOrders) || currentOrders === null }
                           />
                        </Col>
                     </Row>
                     <Row className="mt-3">
                        <Col xxl="3" style={{ textAlign: "right", color: "white" }}>
                           <Input
                              type="radio"
                              id="HistoryOrders"
                              name="orderType"
                              value={RadioButttonTypes.HISTORY}
                              checked={currentRadio === RadioButttonTypes.HISTORY}
                              onChange={() => radioSwitch(RadioButttonTypes.HISTORY)}
                           />
                           <Label
                              style={{ color: "white" }}
                              htmlFor="HistoryOrders"
                              className="ms-2"
                           >
                              History Orders
                           </Label>
                        </Col>
                        <Col xxl="4">
                           <Select
                              classNamePrefix="serviceThreadSelect"
                              options={historyOrders}
                              value={currentOrder}
                              onChange={(opt) => setCurrentOrder(opt)}
                              isDisabled={ _.isEmpty(historyOrders) || historyOrders === null }
                              onMenuOpen={loadOptions} // Trigger loading when menu is opened
                              components={{
                                 Menu: (props) => (
                                    <components.Menu {...props} style={customStyles.menu} />
                                 ),
                                 MenuList,
                              }}
                           />
                        </Col>
                     </Row>
                     <Row className="mt-3">
                        <Col xxl="3" style={{ textAlign: "right", color: "white" }}>
                           Item:
                        </Col>
                        <Col xxl="4">
                           <Select
                              classNamePrefix="serviceThreadSelect"
                              options={currentItems}
                              value={currentItem}
                              onChange={(opt) => setCurrentItem(opt)}
                           />
                        </Col>
                     </Row>
                     <Row className="mt-3">
                        <Col xxl="3" />
                        <Col>
                           <Button className="shredButton" onClick={() => runCoAReport()} >
                              VIEW COA
                           </Button>
                        </Col>
                     </Row>
                  </>
               )}
            </div>
         </DesktopContainer>
      )
   );
}
